// =============================================================================
// frontend/src/shared/passwordPolicy.js
// SINGLE SOURCE OF TRUTH for password rules on the frontend (#consistency P2/E).
// Mirrors the backend exactly (backend/app/services/password_policy.py:_PASSWORD_RE).
// Imported by EVERY password form (LoginForm, WladminLogin, SettingsTab, PartnerLogin)
// so the rule lives in ONE place — previously it was copied 4 ways (and PartnerLogin
// only checked length, letting weak passwords through to a backend reject).
// Bundled into all 3 esbuild entries (app / wladmin / partner).
// =============================================================================

// 12+ chars, ≥1 lowercase, ≥1 uppercase, ≥1 digit, ≥1 special — identical char
// class to the backend regex.
const PASSWORD_RE =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{}|;:'".,<>?/`~\\]).{12,}$/;

export const PASSWORD_MIN_LENGTH = 12;

export const PASSWORD_REQUIREMENTS =
  'Password must be at least 12 characters and include an uppercase letter, ' +
  'a lowercase letter, a digit, and a special character.';

const SPECIAL_RE = /[!@#$%^&*()_+\-=\[\]{}|;:'".,<>?/`~\\]/;

/** True if the password meets the full policy. */
export function validatePassword(pw) {
  return PASSWORD_RE.test(pw || '');
}

/** Per-rule breakdown for strength-meter / checklist UIs. */
export function passwordChecks(pw) {
  const p = pw || '';
  return {
    len: p.length >= PASSWORD_MIN_LENGTH,
    upper: /[A-Z]/.test(p),
    lower: /[a-z]/.test(p),
    digit: /[0-9]/.test(p),
    special: SPECIAL_RE.test(p),
  };
}
